import React from 'react';

import { ITicketsFilter } from './types';
import { ReactComponent as ActiveIcon } from '../../../../assets/active.icon.svg';
import { ReactComponent as TicketIcon } from '../../../../assets/tickets.icon.svg';
import { ReactComponent as UnActiveIcon } from '../../../../assets/unactive.icon.svg';

export const ticketFilters: ITicketsFilter[] = [
  {
    name: 'pages.tickets.tabs.all',
    icon: <TicketIcon />,
    filterValue: '',
    isClosed: null,
    value: 0,
  },
  {
    name: 'pages.tickets.tabs.open',
    icon: <ActiveIcon />,
    filterValue: 'openStatusId',
    isClosed: false,
    value: 1,
  },
  {
    name: 'pages.tickets.tabs.closed',
    icon: <UnActiveIcon />,
    filterValue: 'closeStatusId',
    isClosed: true,
    value: 2,
  },
];

export const customFilterNames: string[] = ['allStatuses', 'openStatuses', 'closedStatuses']
